import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ProductNomenclatureModel } from '../models/product.nomenclature.model';
import { PrintGroupModel } from '../models/product.printgroup.model';
import { ProductCategoryService } from '../services/productcategory.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-searchresults',
  templateUrl: './searchresults.component.html',
  styleUrls: ['./searchresults.component.css']
})
export class SearchresultsComponent implements OnInit {

  searchTerm: string;
  public productNomenclatures: ProductNomenclatureModel[] = [];
  baseUrl = environment.baseUrl;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProductCategoryService
  ) {
      this.searchTerm = this.route.snapshot.params.searchterm;

   }

  ngOnInit(): void {
    this.service.getSearchResults(this.searchTerm)
    .subscribe(
      (data=>
      {
         this.productNomenclatures = data;
         //console.log('mnc');
         //console.log(this.productNomenclatures);
      }),
      (error=>
      {
        console.log(error);
      })
    );

  }


}
